import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// Must be the first application import — the IIFE inside this module patches
// Storage.prototype before Angular bootstraps and before any field initializer
// or service constructor accesses localStorage.
import './app/services/secure-storage.service';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // Clears all console logs in PRODUCTION!
  if (window) {
    window.console.log = function () { };
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
